import { Create, CreateProps } from 'react-admin';
import { AdminTitle, formWrapper } from '.';

export default function CustomCreate(props: CreateProps) {
  return (
    <>
      <AdminTitle />
      {formWrapper({ ...props })(Create)}
    </>
  );
}
